import { HeapEvent } from '../config';

type NavLabels = {
  webLabel: string,
  mobileLabel: string,
  key: string,
  heapEvent: string,
}

type SubfiltersByMealType = {
  programs: NavLabels[],
  view_all: NavLabels[],
  meal_kits: NavLabels[],
  ready_to_eat: NavLabels[],
  grocery: NavLabels[],
};

class Nav {
  static less_prep = {
    webLabel: 'Less Prep',
    mobileLabel: 'Less Prep',
    key: 'less_prep',
    heapEvent: HeapEvent.ANCHOR_LESS_PREP,
  };

  static dinner = {
    webLabel: 'Dinner',
    mobileLabel: 'Dinner',
    key: 'dinner',
    heapEvent: HeapEvent.ANCHOR_MEALKITS,
  };

  static lunch = {
    webLabel: 'Lunch',
    mobileLabel: 'Lunch',
    key: 'lunch',
    heapEvent: HeapEvent.ANCHOR_LUNCH,
  };

  static breakfast = {
    webLabel: 'Breakfast',
    mobileLabel: 'Breakfast',
    key: 'breakfast',
    heapEvent: HeapEvent.ANCHOR_BREAKFAST,
  };

  static rte_dinner = {
    webLabel: 'Dinner',
    mobileLabel: 'Dinner',
    key: 'rte_dinner',
    heapEvent: HeapEvent.ANCHOR_RTE_DINNER,
  };

  static rte_lunch = {
    webLabel: 'Lunch',
    mobileLabel: 'Lunch',
    key: 'rte_lunch',
    heapEvent: HeapEvent.ANCHOR_RTE_LUNCH,
  };

  static rte_breakfast = {
    webLabel: 'Breakfast',
    mobileLabel: 'Breakfast',
    key: 'rte_breakfast',
    heapEvent: HeapEvent.ANCHOR_RTE_BREAKFAST,
  };

  static pantry = {
    webLabel: 'Pantry',
    mobileLabel: 'Pantry',
    key: 'grocery',
    heapEvent: HeapEvent.ANCHOR_PLANTRY,
  };

  static bundle = {
    webLabel: 'Bundles',
    mobileLabel: 'Bundles',
    key: 'bundle',
    heapEvent: HeapEvent.ANCHOR_BUNDLE,
  };

  static view_all = {
    webLabel: 'VIEW ALL',
    mobileLabel: 'View All',
    key: 'view_all',
    heapEvent: null,
  };

  static programs = {
    webLabel: 'YOUR PROGRAM',
    mobileLabel: 'Your Program',
    key: 'programs',
    heapEvent: HeapEvent.ANCHOR_PROGRAMS,
  };

  static meal_kits = {
    webLabel: 'MEAL KITS',
    mobileLabel: 'Meal Kits',
    key: 'meal_kits',
    heapEvent: HeapEvent.ANCHOR_MEALKITS,
  };

  static ready_to_eat = {
    webLabel: 'READY TO EAT',
    mobileLabel: 'Ready-to-Eat',
    key: 'ready_to_eat',
    heapEvent: HeapEvent.ANCHOR_FRESHPREPARED,
  };

  static grocery = {
    webLabel: 'GROCERY',
    mobileLabel: 'Grocery',
    key: 'grocery',
    heapEvent: HeapEvent.ANCHOR_PLANTRY,
  };

  static webFilters = [Nav.programs, Nav.view_all, Nav.meal_kits, Nav.ready_to_eat, Nav.grocery]

  static webSubFiltersWithRteDayparts = {
    programs: [],
    view_all: [Nav.dinner, Nav.lunch, Nav.breakfast, Nav.pantry],
    meal_kits: [Nav.dinner, Nav.lunch, Nav.breakfast],
    ready_to_eat: [Nav.rte_dinner, Nav.rte_lunch, Nav.rte_breakfast],
    grocery: [],
  }

  static webSubFilters = {
    programs: [],
    view_all: [Nav.dinner, Nav.lunch, Nav.breakfast, Nav.pantry],
    meal_kits: [Nav.dinner, Nav.lunch, Nav.breakfast],
    ready_to_eat: [],
    grocery: [],
  }

  static programSubFilters = [Nav.breakfast, Nav.lunch, Nav.dinner];

  static getWebSubFilters = (isRteDaypartFiltersEnabled: boolean): SubfiltersByMealType => (
    isRteDaypartFiltersEnabled ? Nav.webSubFiltersWithRteDayparts : Nav.webSubFilters
  )
}
export default Nav;
